module.exports = __webpack_public_path__ + "img/realtime_log.3a3fafae.png";